module.exports = __webpack_public_path__ + "img/33_bohle.932b9f54.jpeg";